

import { Component, Prop, Vue } from 'vue-property-decorator';
import { form22StatusInfoType } from '@/types/Information/Form22';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form22ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form22StatusInfoType;

}
